import { render } from "./verification_component.html?vue&type=template&id=11982656&external"
import script from "./verification_component.js?vue&type=script&lang=js&external"
export * from "./verification_component.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__